import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "radio", "prevBtn", "nextBtn", "counter", "thumbnail"]

  connect() {
    this.index = this.slideTargets.findIndex(s => !s.classList.contains("hidden"))
    if (this.index < 0) this.index = 0
    this.showSlide(this.index)
  }

  prev(event) {
    event.stopPropagation()
    const total = this.slideTargets.length
    if (total <= 1) return
    this.showSlide((this.index - 1 + total) % total)
  }

  next(event) {
    event.stopPropagation()
    const total = this.slideTargets.length
    if (total <= 1) return
    this.showSlide((this.index + 1) % total)
  }

  select() {
    this.radioTarget.checked = true
  }

  goTo(event) {
    this.showSlide(event.params.index)
  }

  showSlide(index) {
    this.index = index
    this.slideTargets.forEach((slide, i) => slide.classList.toggle("hidden", i !== index))
    this.thumbnailTargets.forEach((thumbnail, i) => {
      thumbnail.classList.toggle("ring-2", i === index)
      thumbnail.classList.toggle("ring-[#C4531A]", i === index)
      thumbnail.classList.toggle("opacity-60", i !== index)
    })
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${index + 1} / ${this.slideTargets.length}`
    }
  }
}
